<template functional>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="props.size" :height="props.size" viewBox="0 0 24 24">
    <defs>
      <clipPath id="clip-path">
        <rect id="Rectangle_17315" data-name="Rectangle 17315" width="24" height="24" transform="translate(205 389)" fill="#fff"/>
      </clipPath>
    </defs>
    <g id="ico_-_hide_password_-_default" data-name="ico - hide password - default" transform="translate(-205 -389)" clip-path="url(#clip-path)">
      <g id="Icon_feather-eye-off" data-name="Icon feather-eye-off" transform="translate(207.5 392.5)">
        <path id="Path_6714" data-name="Path 6714" d="M13.82,14.771a8.081,8.081,0,0,1-4.32,1.3c-5.091,0-8-5.034-8-5.034A12.246,12.246,0,0,1,5.18,7.3M7.973,6.151A7.623,7.623,0,0,1,9.5,6c5.091,0,8,5.034,8,5.034a11.71,11.71,0,0,1-1.571,2.007m-4.887-.673a2.408,2.408,0,0,1-2.136.542,2.056,2.056,0,0,1-1.574-1.362A1.73,1.73,0,0,1,7.958,9.7" transform="translate(0 -2.534)" fill="none" stroke="#74788d" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
        <path id="Path_6715" data-name="Path 6715" d="M1.5,1.5l16,14" transform="translate(0 0)" fill="none" stroke="#74788d" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconEyeSlash',

  props: {
    size: { type: [String, Number], default: '24px' },
  }
}
</script>